import { makeSceneLookup, type Scene } from '@/designs-dev/scenes';

/** What the control panel has behind a circle. See ControlPanel's `intake`. */
export type CamIntakeInitial = { intake?: 'consented' | 'declined' };

// The three states the CAM side of Tell Us Once can be in, paired with the prop
// that drives them. Shared by the live state select on this project's CAM
// prototype and the CAM overview flows page, so the set is defined once.
//
// The care-search catalog is the wrong set on this page: its scenes are states
// of the Care search tab, and this page opens on Overview, so picking one
// changed something nobody could see. These are the states Overview actually
// has.
export const camIntakeScenes: Scene<CamIntakeInitial>[] = [
  {
    id: 'none',
    label: 'No intake (as it ships)',
    kind: 'view',
    repro: 'The overview as production draws it, before any of this exists',
    initial: {},
  },
  {
    id: 'consented',
    label: 'Intake behind it',
    kind: 'happy',
    repro:
      'A member has been through the intake and consented to AI processing',
    initial: { intake: 'consented' },
  },
  {
    id: 'declined',
    label: 'AI processing declined',
    kind: 'edge',
    repro:
      'Nothing on the circle was read from what the family sent, so the read-back does not exist and no fact is machine-filled',
    initial: { intake: 'declined' },
  },
];

export const camIntakeScene = makeSceneLookup(camIntakeScenes);
